export const GID_REGEX = /^(?<type>[0-9a-zA-Z]+)_(?<id>.*?)$/
export const PREFIX_MAPPING = {
  Account: 'ac',
  Agent: 'ag',
  AgentChanged: 'agch',
  Article: 'art',
  ArticleAttachment: 'aa',
  ArticleRating: 'ar',
  Attachment: 'at',
  CannedReply: 'cr',
  CannedReplyCategory: 'crc',
  Changeset: 'cs',
  ChangesetGroup: 'csg',
  Channel: 'ch',
  ChannelChanged: 'chch',
  Company: 'cm',
  Condition: 'cnd',
  Contact: 'co',
  ContactChange: 'coch',
  ContactOpenedMessage: 'coo',
  Conversation: 'cnv',
  ConversationDeleted: 'cnvd',
  ConversationMerged: 'cnvm',
  ConversationRestored: 'cnvr',
  ConversationStarred: 'cnvs',
  ConversationUnstarred: 'cnvus',
  CustomerReadChange: 'crd',
  CustomField: 'cf',
  CustomFieldCategory: 'cfc',
  CustomFieldValue: 'cfv',
  Draft: 'dra',
  EmailMessage: 'msg',
  EmailMarketingIntegration: 'emi',
  EmailMarketingIntegrationMailboxSetting: 'emims',
  Event: 'evt',
  ExcludedDomain: 'exd',
  Folder: 'fol',
  FollowerAdded: 'fla',
  FollowerRemoved: 'flr',
  Handle: 'hdl',
  IntegrationAdded: 'inta',
  IntegrationExternalChange: 'inte',
  IntegrationRemoved: 'intr',
  KbCategory: 'kbc',
  KnowledgeBase: 'kb',
  Label: 'lbl',
  Message: 'msg',
  Rating: 'rat',
  Rule: 'rul',
  Segment: 'sg',
  Snoozed: 'snz',
  StateChanged: 'stc',
  SubjectChanged: 'subjc',
  Tag: 'tag',
  Tagged: 'cnvt',
  Team: 'tm',
  TeamChanged: 'tmc',
  Theme: 'thm',
  Unsnoozed: 'unsnz',
  Untagged: 'unt',
  Widget: 'wid',
}

const TYPE_LOOKUP = Object.keys(PREFIX_MAPPING).reduce((lookup, type) => {
  const prefix = PREFIX_MAPPING[type]
  // eslint-disable-next-line no-param-reassign
  lookup[prefix] = type
  return lookup
}, {})

export function buildId(type, id) {
  return `${PREFIX_MAPPING[type]}_${id}`
}

export function getRawId(id) {
  if (!id) return null
  if (!id.includes('_')) return id
  const seperatorIndex = id.indexOf('_')
  const type = id.substr(0, seperatorIndex)
  if (!TYPE_LOOKUP[type]) return null
  return id.substr(seperatorIndex + 1)
}

export function isGid(id) {
  if (!id) return false
  const strId = id.toString()
  const match = strId.match(GID_REGEX)
  if (!match) return false
  if (!TYPE_LOOKUP[match.groups.type]) return false

  return true
}
